import React, { useState, useEffect } from 'react';
import EmployerBase from './EmployerBase';
import Api from '../Services/ApiCall';
import '../../Css/Pagination.css';
import { Modal, Button } from 'react-bootstrap';
import { Link, useLocation, useNavigate } from "react-router-dom";
import Swal from 'sweetalert2';
import { set } from 'date-fns';
import Base from '../Base';

export default function EmployerSubscribeform() {
    const location = useLocation();
    const { ID, Flag, Code } = location.state;
    const [plans, setPlans] = useState([]);
    const [selectedPlan, setSelectedPlan] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [popup, setpopup] = useState(false);
    const [plan_Amount, setPlan_Amount] = useState("");
    const [choosePlan, setChoosePlan] = useState("");
    const [plan_id, setplan_id] = useState("");
    const [duration, setplan_duration] = useState("");
    const [downloadcount, setdownloadcount] = useState("");
    const [postcount, setpostcount] = useState("");
    const [resumedownloadcount, setresumedownloadcount] = useState("");
    const [jobpostcount, setjobpostcount] = useState("");
    const [Tax, setTax] = useState();
    const navigate = useNavigate();

    // Fetch employer plans
    useEffect(() => {
        const fetchPlans = async () => {
            try {
                const requestData = {
                    mstemployerplanid: 0
                };
                var url = "/EmployerPlanCreation/BindEmployerPlan";
                let _response1 = await Api.BindGrid(requestData, url)

                try {
                    setPlans(_response1);
                } catch (parseError) {
                    console.error("Error parsing plans:", parseError);
                    setError("Invalid plan data format");
                }
            } catch (err) {
                setError(err.message);
                console.error("Error fetching plans:", err);
            } finally {
                setLoading(false);
            }
        };

        fetchPlans();
        GetTax();
    }, []);
    async function GetTax() {
        var Param = { msttaxid: 0, notificationcode: "000002" }
        var url = "/Notification/BindNotification";
        let _response = await Api.BindGrid(Param, url)
        setTax(_response[0].Messages);
    }
    function closeModal2() {
        setpopup(false);
    }
    const handlePlanSelect = (plan) => {
        setSelectedPlan(plan);
    };

    const handleBuyPlan = (plan) => {
        if (!plan) {
            Swal.fire({
                icon: 'warning',
                title: 'No Plan Selected',
                text: 'Please select a plan before proceeding'
            });
            return;
        }
        setChoosePlan(plan.Plantype);
        setPlan_Amount(plan.Applyamount);
        setplan_id(plan.mstemployerplanid);
        setplan_duration(plan.Duration);
        setdownloadcount(plan.Extra2);
        setpostcount(plan.Extra3);
        setresumedownloadcount(plan.Downloadamount);
        setjobpostcount(plan.Extra1);
        setpopup(true);

    };

    if (loading) {
        return (
            <div className="text-center py-5">
                <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
                <p>Loading plans...</p>
            </div>
        );
    }

    if (error) {
        return (
            <div className="alert alert-danger mx-3 my-5">
                Error loading plans: {error}
            </div>
        );
    }

    return (
        <div>
            {sessionStorage.getItem("AccessType") == 'Employer' ?
                <EmployerBase /> : null}
            {sessionStorage.getItem("AccessType") == 'Employee' ||
                sessionStorage.getItem("AccessType") == 'Agent' ||
                sessionStorage.getItem("AccessType") == 'User'
                ?
                <Base /> : null}
            <div id="main" className="main">
                <div className="pagetitle">
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">Employer Subscription Plans</li>
                        </ol>
                    </nav>
                </div>

                <section>
                    <div className="container">
                        <div className="outer-box">
                            <div className="row">
                                {plans.map((plan) => (
                                    <div key={plan.Mstemployerplanid} className="pricing-block col-lg-4 col-md-4 col-sm-12 wow fadeInUp" data-wow-delay="400ms">
                                        <div className={`inner-box ${selectedPlan?.Mstemployerplanid === plan.Mstemployerplanid ? 'selected-plan' : ''}`}>
                                            <div className="icon-box">
                                                <div className="icon-outer">
                                                    <i className={`fas ${plan.Plantype.includes('Scheme A') ? 'fa-gem' :
                                                        plan.Plantype.includes('Scheme B') ? 'fa-crown' :
                                                            plan.Plantype.includes('Scheme C') ? 'fa-star' :
                                                                'fa-rocket'
                                                        }`}></i>
                                                </div>
                                            </div>
                                            <div className="price-box">
                                                <h3>{plan.Plantype}</h3>
                                                <div className="form-check subscribe">
                                                    <input
                                                        className="form-check-input"
                                                        type="radio"
                                                        name="flexRadioDefault"
                                                        checked={selectedPlan?.Mstemployerplanid === plan.Mstemployerplanid}
                                                        onChange={() => handlePlanSelect(plan)}
                                                    />
                                                    <label for="flexRadioDefault" className="form-check-label sub1">
                                                        Select Plan
                                                    </label>
                                                </div>
                                                {selectedPlan?.Mstemployerplanid === plan.Mstemployerplanid && (
                                                    <div className="text-center mt-3">
                                                        <div className="selected-plan-summary p-3 mb-3">
                                                            <p>Total Amount: ₹<strong>{plan.Applyamount}</strong></p>
                                                        </div>
                                                        <button
                                                            className="btn btn-primary btn-lg"
                                                            onClick={() => handleBuyPlan(plan)}
                                                        >
                                                            Proceed to Payment
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>

                <Modal show={popup} className='model-popup-design' style={{ marginBottom: "100px" }}>
                    <Modal.Header classname="Userlgnmodalhead">
                        <Modal.Title>
                            Plan confirmation
                        </Modal.Title>
                        <button type="button" class="btn-close" data-dismis="modal" onClick={closeModal2} arial-label="Close"></button>
                    </Modal.Header>
                    <div className='loginmodalbody'>
                        <Modal.Body className='testing-test'>
                            <div>
                                <h5>Dear Employer, You Selected the <strong>{choosePlan}</strong> Plan.</h5>

                                <div className="mt-3">
                                    <h6>Your Plan Amount: <strong>₹{plan_Amount}</strong></h6>
                                    <h6>Duration (in days): <strong>{duration}</strong></h6>
                                    <h6>You can download <strong>{downloadcount}</strong> resumes for free.</h6>
                                    <h6>You can post <strong>{postcount}</strong> jobs for free.</h6>
                                    <h6>Additional Resume Download Charge: <strong>₹{resumedownloadcount}</strong></h6>
                                    <h6>Additional Job Post Charge: <strong>₹{jobpostcount}</strong></h6>
                                </div>
                            </div>
                        </Modal.Body>
                    </div>

                    <Modal.Footer>
                        <Button style={{ backgroundColor: "#4CAF50", color: "white", border: "none" }}>
                            <Link to="/Payment"
                                state={{ Amount: plan_Amount, Code: Code, Planperiod: plan_id, Plan: choosePlan, ID: 0, Tax: Tax, Coupon: "0", Coupon_Percent: "0" }}
                                style={{ color: "white", textDecoration: "none" }}>
                                Ok
                            </Link>
                        </Button>
                        <Button style={{ backgroundColor: "#FF5733", color: "white", border: "none" }} onClick={closeModal2}>
                            Cancel
                        </Button>
                    </Modal.Footer>

                </Modal>

            </div>
        </div>
    );
}